<template>
  <form @submit="onCreate">
    <div class="form-group">
      <select class="form-control selector" v-model="fixed.enumName">
        <option
          v-for="(connector, index) in fixedConnectors"
          :key="index"
          :value="connector.value"
          :selected="index == 0"
        >
          {{ connector.name }}
        </option>
      </select>
    </div>

    <div class="footer">
      <button class="btn btn-md btn-primary" @click="onCreate">
        {{ $t("template.cr-tp-btn-create") }}
      </button>
      <button class="btn btn-md btn-secondary" type="reset" @click="$emit('close')">
        {{ $t("template.cr-tp-btn-cancel") }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      fixed: {
        enumName: "Shopify",
        name: "",
      }
    };
  },

  methods: {
    onCreate(evt) {
      evt.preventDefault();
      this.$emit("onSave", this.fixed.enumName);
      this.$emit("close");
    }
  },
  computed: {
    fixedConnectors() {
      return this.$store.state.fixedConnectors;
    },
  }
};
</script>

<style lang="less">
#integration-modal {
  padding: 30px 25px 25px 25px;
  .form-group {
    margin-bottom: 30px;
  }
  h1 {
    font-size: 24px;
    margin: 0;
  }
  .footer {
    margin-top: 10px;
  }
  .footer img {
    width: 35px;
    position: absolute;
    left: calc(25px);
  }
  .radio-btns {
    color: #8f979c;
    padding-top: 12px;
  }
}
</style>
